import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TripwireLanding from './TripwireLanding';
import SuccessPage from './SuccessPage';
import GoogleTagManagerTracker from './GoogleTagManagerTracker';
import SandboxBanner from './SandboxBanner';

function App() {
  return (
    <BrowserRouter>
      <GoogleTagManagerTracker />
      <SandboxBanner />
      <Routes>
        <Route path="/" element={<TripwireLanding />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
